const cards = [
  {
    title: "Deploy",
    accent: "#3b82f6",
    icon: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12",
    body: "AI agents built for specific professional workflows. Each agent handles document processing, form preparation, compliance checking, and case assembly. Professionals review every output.",
  },
  {
    title: "Manage",
    accent: "#8b5cf6",
    icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
    body: "As your AI workforce grows, orchestrate across teams. Identity and access controls per agent. Cost tracking. Usage monitoring. Human oversight where it matters.",
  },
  {
    title: "Govern",
    accent: "#10b981",
    icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
    body: "Full audit trails on every AI action. Compliance gates before submission. Quality monitoring across your agent portfolio. Regulator-ready reporting built in.",
  },
];

export function IntroApproachSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-2 font-[family-name:var(--font-heading)]">
        Deploy, manage, and govern AI agents at every stage of maturity.
      </h2>
      <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-4">
        Most AI tools are point solutions. COSX is a platform designed for the full lifecycle of AI agent adoption in regulated environments.
      </p>

      <div className="flex gap-4">
        {cards.map((card) => (
          <div key={card.title} className="flex-1 flex flex-col border border-[var(--color-border)] rounded-sm overflow-hidden">
            <div className="h-[3px]" style={{ background: card.accent }} />
            <div className="px-4 py-3">
              <div className="flex items-center gap-2 mb-2">
                <svg className="w-4 h-4 shrink-0" style={{ color: card.accent }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d={card.icon} />
                </svg>
                <h3 className="text-[13px] font-medium">{card.title}</h3>
              </div>
              <p className="text-[11px] text-[var(--color-fg-secondary)] leading-relaxed">{card.body}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <div className="flex items-center gap-1 text-[11px] mb-1">
          <span className="font-medium">Running today:</span>
          <span className="text-[var(--color-fg-secondary)]">AI Paralegal Agents</span>
          <span className="text-emerald-500 bg-emerald-500/10 text-[7px] font-[family-name:var(--font-mono)] tracking-widest uppercase px-1.5 py-0.5 rounded-sm">Live</span>
          <span className="text-[var(--color-fg-tertiary)] mx-1">/</span>
          <span className="text-[var(--color-fg-secondary)]">AI Learning Agents</span>
          <span className="text-amber-500 bg-amber-500/10 text-[7px] font-[family-name:var(--font-mono)] tracking-widest uppercase px-1.5 py-0.5 rounded-sm">Launching</span>
          <span className="text-[var(--color-fg-tertiary)] mx-1">/</span>
          <span className="text-[var(--color-fg-secondary)]">AI Advisory Agents</span>
          <span className="text-[var(--color-fg-tertiary)] bg-[var(--color-fg-tertiary)]/10 text-[7px] font-[family-name:var(--font-mono)] tracking-widest uppercase px-1.5 py-0.5 rounded-sm">In dev</span>
        </div>
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Your AI agents work under the same governance your professionals do.
        </p>
      </div>
    </div>
  );
}
